import { levelEnum } from "@/utilities/enum";

export default {
  methods: {
    resolveUserRole(roles = []) {
      if (roles.includes("ADMIN")) return levelEnum.ADMIN;
      if (roles.includes("OHS")) return levelEnum.OHS;
      if (roles.includes("REPORTER")) return levelEnum.REPORTER;
      if (roles.includes("ENVIRONMENT")) return levelEnum.ENVIRONMENT;
      if (roles.includes("IMPROVEMENT")) return levelEnum.IMPROVEMENT;
      if (roles === levelEnum.KONTRAKTOR) return levelEnum.KONTRAKTOR;
      if (roles === levelEnum.EXTERNAL) return levelEnum.EXTERNAL;

      return levelEnum.ISAFE;
    },
  },
};
